<template>
    <div class="projectAddress-box">
        <van-nav-bar
            :title="title||'定位'"
            left-text=""
            left-arrow
            @click-left="clickLeft"
        ></van-nav-bar>
        <div class="container">
            <div class="search-box">
                <input type="text" v-model="search" placeholder="请输入位置名称">
                <span class="search-btn" @click="keyword=search">搜索</span>
                <van-action-sheet v-model="showSearchList" :actions="searchListActions" @select="selectLocation"></van-action-sheet>
            </div>
            <baidu-map
                class="map"
                ref="map"
                :center="location.position"
                :zoom="zoom"
                @ready="mapReady"
                @click="clickMap"
            >
                <bm-local-search
                    :keyword="keyword"
                    :auto-viewport="true"
                    :panel="false"
                    location="全国"
                    @markersset="markersset"
                ></bm-local-search>
                <bm-marker
                    :position="location.position"
                >
                    <bm-info-window
                        v-if="location.address"
                        :position="location.position"
                        title=""
                        :show="true"
                    >
                        <div style="padding-top: 20px">
                            {{ location.address }}
                        </div>
                    </bm-info-window>
                </bm-marker>
                <!-- 电子围栏 -->
                <bm-polyline
                    :path="fencePoint"
                    stroke-color="#80d8ff"
                    fill-color="#00b0ff"
                    :fill-opacity="0.3"
                    :stroke-weight="2"
                    @click="clickPolyline"
                ></bm-polyline>
            </baidu-map>
            <div class="btn-con" id="correctPosition" @click="sureBack">
                <span class="btn">
                    确定
                </span>
            </div>
            <div class="getCurrentPosition" @click="getCurrentPosition">
                <span class="iconfont icondingwei"></span>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import { HeaderNav } from '@/components/';
import BMapLib from '@/assets/map/BMapLib.js';
import { eventBus } from '@/common/eventBus.ts';
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
    ak: '8oGi1YBeLNnGA54yA1YuyumkzjjfGqmW',
});
export default {
    components: {
        HeaderNav,
    },
    props: {
    },
    data() {
        return {
            title:'',
            BMap: null,
            keyword: '',
            zoom: 14,
            searchOption: {
                city: '全国',
                citylimit: false
            },
            search: '',
            showSearchList: false,
            searchList: [],
            searchListActions: [],
            defaultSearch: '',
            fencePoint: [], // 电子围栏
            // 定位信息
            location: {
                position: {lng: 116.397428, lat: 39.90923},
                address: '',
            }
        };
    },
    watch: {},
    computed: {},
    created() {
        window.jyCallback_DriverUntieVehicle = this.jyCallback_DriverUntieVehicle;
    },
    methods: {
        mapReady({ BMap, map }) {
            this.BMap = BMap;
            this.init();
        },
        clickMap ({point}) {
            this.location.position = point;
            this.getAddress();
        },
        // 搜索结果
        markersset(pois) {
            this.searchList = pois;
            this.searchListActions = pois.map(item=> {
                return {
                    name:  item.title
                }
            });
            this.showSearchList = true;
        },
         // 选择搜索位置
        selectLocation(item) {
            const loc = this.searchList.find(o=> o.title === item.name);
            this.location.position = loc.point;
            this.location.address = loc.address + loc.title;
            this.showSearchList = false;
        },
        // 初始化
        init() {
            this.title = this.$route.params.title;
            this.location.position.lng = this.$route.params.lng;
            this.location.position.lat = this.$route.params.lat;
            this.location.address = this.$route.params.address;
            const fencePoint = this.$route.params.fencePoint;
            if(fencePoint) {
                this.fencePoint = this.formatFencePoint(fencePoint);
            }
            if(!(this.location.position.lng && this.location.position.lat)) {
                this.getCurrentPosition();
            }
        },
        // 格式化电子围栏点
        formatFencePoint(fence_point) {
            const arr = fence_point.split('|');
            const result = arr.map(item=>{
                const lngLat = item.split(',');
                return {lng: lngLat[0], lat: lngLat[1]};
            });
            return result;
        },
        // 打点显示信息窗
        getAddress() {
            const geocoder = new this.BMap.Geocoder();
            geocoder.getLocation(this.location.position,  (result) => {
                if (result) {
                    let sur = '';
                    if(result.surroundingPois.length>0) {
                        sur = result.surroundingPois[0].title;
                    }
                    this.location.address = result.address + sur;
                }else{
                    this.$toast('根据经纬度查询地址失败')
                }
            });
        },
        // 是否在电子围栏范围内
        isPointInRing() {
            if(this.fencePoint.length === 0) {
                return true;
            }
            return BMapLib.GeoUtils.isPointInPolygon(this.location.position, this.fencePoint);
        },
        // 获取当前定位
        getCurrentPosition() {
            this.$callMobile('JYExternalNative', 'jyDriverUntieVehicleEvent');
        },
        // 获取原生定位后回调
        jyCallback_DriverUntieVehicle(data) {
            // const dataParse = {
            //     address: '北京市丰台区大成路6号靠近中国建设银行（大成路）',
            //     latitude: 39.888844,
            //     longitude: 116.272051,
            // };
            const dataParse = JSON.parse(data);
            if (dataParse.address!=='cs') {
                this.location.position = {lng: dataParse.longitude,lat: dataParse.latitude,};
                this.location.address = dataParse.address;
            }
        },

        // 点击电子围栏内
        clickPolyline({point}) {
            this.location.position = point;
            this.center = point;
            this.getAddress();
        },
        // 确定返回
        sureBack() {
            if (this.isPointInRing()) {
                this.$router.isBack = 1;
                this.$router.go(-1);
                // 选择位置成功
                eventBus.$emit('location', this.location);
            } else {
                this.$toast('当前收货地址不在电子围栏范围内，请重新标注收货地址！');
            }

        },

        clickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="stylus">
.projectAddress-box
    height 100%
    .back
        position absolute
        top 10rpx
        left 15rpx
        z-index 10000
        color #fff
    .container
        height calc(100% - 44rpx)
        position relative
        .search-box
            width: 100%;
            padding: 20rpx;
            position: absolute;
            left: 0;
            z-index: 2;
            display flex
            input
                flex 1
                border: 1px solid #dedede;
                padding: 8rpx;
            .search-btn
                background #0189FC
                color #fff
                border-radius 0 3rpx 3rpx 0
                width: 50rpx;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size 16rpx
        .map
            height 100%
        .btn-con
            position absolute
            bottom 40rpx
            width 100%
            text-align center
            .btn
                background #D6010F
                border-radius 20rpx
                padding 10rpx 20rpx
                color #fff
        .getCurrentPosition
            position absolute
            bottom 30rpx
            left 10rpx
            width 30rpx
            height 30rpx
            background #fff
            border 1px solid #ccc
            box-shadow 1px 1px 10px 0 #ccc
            text-align center
            line-height 28rpx
            border-radius 3rpx
            &:hover
                color #5588F1
</style>
